import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CLIENTS_QUERY_KEYS } from "Clients/Api/Queries/queryKeys";
import {
  putClientsClientID,
  type SaveClientRequest,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

interface UpdateClientParams {
  clientID: string;
  data: SaveClientRequest;
}

export function useUpdateClientMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(({ clientID, data }: UpdateClientParams) =>
    putClientsClientID(data, clientID),
  );

  return useMutation({
    mutationFn,
    onSuccess: (_, { clientID }) => {
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.all,
      });
      queryClient.invalidateQueries({
        queryKey: CLIENTS_QUERY_KEYS.detail(clientID),
      });
    },
  });
}
